import { render, staticRenderFns } from "./PostbackLogs.vue?vue&type=template&id=148f7935&scoped=true"
import script from "./PostbackLogs.vue?vue&type=script&lang=js"
export * from "./PostbackLogs.vue?vue&type=script&lang=js"
import style0 from "./PostbackLogs.vue?vue&type=style&index=0&id=148f7935&prod&lang=scss"
import style1 from "./PostbackLogs.vue?vue&type=style&index=1&id=148f7935&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148f7935",
  null
  
)

export default component.exports